export const spanishTexts = {
  continue: "Continuar",
  loginButton: "Iniciar sesión con correo electrónico",
  registerButton: "Registrarme",
  emailField: "Correo electrónico",
  passField: "Constraseña",
  warnEmailField: "Por favor ingresa tu correo",
  warnPassField: "Por favor ingresa tu contraseña",
  warnPassFormat: "La contraseña de debe contener: ",
  warnPassUpper: "Mayúscula",
  warnPassLower: "Minúscula",
  warnPassNumber : "Número",
  warnPassChar: "Caractér especial",
  warnPassLong: "al menos 12 caractéres",
  warnConfirmPassField: "Por favor confirma tu contraseña",
  errorLogin: "Correo y/o contraseña incorrectos",
  errorSingUp: "Problema al registrar usuario",
  warnLogin: "No se pudo conectar. Inténtalo de nuevo más tarde",
  warnEmailLogin: "El formato del correo electrónico no es válido",
  warnPassLogin: "El formato de la contraseña no es válido",
  warnPassDiff: "Las contraseñas no coinciden",
  confirmPassField: "Confirmar contraseña",
  access: "Entrar",
  recoverPass: "Recuperar contraseña",
  createAccount: "Crear cuenta",
  acceptTerms: "Aceptar términos y condiciones",
  createFormTitle: "Ingresa los siguientes datos para crear tu cuenta: ",
  didntReceiveEmail: "¿No recibiste el correo de confirmación?",
  sendAgain: "Enviar nuevamente",
  goLogin: "Ir a inicio de sesión",
  modalVerifyEmail: "Te enviamos un correo para la verificación de tu cuenta",
  recoverPassEmailTitle: "Ingresa un correo para recuperar tu contraseña",
  recoverPassTitle: "Ingresa tu nueva contraseña",
  recoverPassButton: "Recuperar",
  recoverPassMsg: "Te enviamos un correo con las instrucciones para la recuperación de tu contraseña",
  recoverPassPass: "Ingresa una contraseña para poder ingresar a tu cuenta nuevamente",
  recoverPassSave: "Guardar",
  passFormat: "La contraseña debe tener al menos 12 caracteres e incluir una letra mayúscula, una minúscula, un carácter especial y un número",
  termsTitle: "Términos y condiciones",
  termsSubTitle: "Política de privacidad",
  termsText: "Lorem ipsum odor amet, consectetuer adipiscing elit. Urna hendrerit sociosqu eget augue iaculis conubia at. Fames iaculis proin nam lorem elit nullam. Conubia primis suspendisse sodales placerat eleifend varius libero condimentum venenatis. At phasellus fusce himenaeos dolor cras sociosqu interdum torquent. Lacus nullam dui maximus; platea tempus augue. Volutpat ornare condimentum elementum netus massa curae enim. Eleifend interdum vivamus eros cursus ante ridiculus elementum in. Tristique sagittis scelerisque volutpat quisque sollicitudin non placerat class.\n" +
    "\n" +
    "Hendrerit turpis cursus urna a vitae; erat placerat elit. Consequat ridiculus congue cras adipiscing mauris cras. Per leo efficitur urna malesuada ullamcorper nullam mus aliquet. Egestas velit donec nisl facilisis hendrerit odio laoreet. Inceptos mollis penatibus adipiscing accumsan laoreet. Litora varius nostra sociosqu ornare, libero cursus. Sit semper class lobortis porta imperdiet convallis habitant eu venenatis. Sodales nulla aliquam bibendum, vivamus laoreet fringilla. Mus donec tristique a quam inceptos condimentum.\n" +
    "\n" +
    "Arcu mollis mollis elementum parturient conubia dui facilisi. Aliquam aliquet malesuada libero est elit. Felis leo dignissim pretium ullamcorper vel accumsan ornare interdum. Nostra ex sagittis litora vivamus senectus proin enim rhoncus dis. Aptent leo vivamus molestie, blandit vivamus posuere pellentesque. Aptent felis finibus elementum gravida praesent non elit enim. Litora dis maximus egestas consectetur mollis. Felis adipiscing posuere cursus imperdiet per quam.",
}